<template>
  <div class="content-quick-stats" v-if="statsByCompany.length">
    <h2>Quick Stats</h2>
    <div class="quick-stats-wrapper">
      <div class="quick-stats"
        v-for="(company, key) in statsByCompany"
        :key="key">
        <div class="header">
          <template v-if="company.companyUrl == ''">
            <img class="stats-logo" :src="company.logoUrl"
            :alt="company.companyName" />
            <h3>{{company.companyName}}</h3>
          </template>
          <a v-else class="company-wrapper"
            v-gtm-tracker="{ trackEV: false, ec: 'Article News/Company name', ea: 'China Tech City News View/Company name/Click', el: company.companyUrl }"
            :href="company.companyUrl">
            <img class="stats-logo" :src="company.logoUrl"
            :alt="company.companyName" />
            <h3>{{company.companyName}}</h3>
          </a>
        </div>
        <div class="infographics">
          <tech-city-infographic
            v-for="(stat, key) in company.stats"
            :stat="stat"
            :key="key"
            class="dont-scale"
          ></tech-city-infographic>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'news-view-quick-stat',
    props: {
      statsByCompany: {
        type: Array,
        required: true,
      },
    },
    mixins: [],
    components: {
      TechCityInfographic: () => import('components/tech-city/widgets/TechCityInfographic.vue'),
    },
    computed: {
    },
    mounted() {
    },
    methods: {
    },
  }
</script>

<style lang="scss" scoped>
  .content-quick-stats {
    @include respond-to(desktop) {
      padding: rem-calc(0 10);    
    }
  }
  h2 {
    margin-bottom: rem-calc(10);
    font-size: rem-calc(16);
    color: $soft-rose;
    font-weight: 500;

    @include respond-to("desktop") {
      font-size: rem-calc(20);
    }
  }
  .company-wrapper {
    display: block;
  }
  .stats-logo {
    width: rem-calc(34);
    height: rem-calc(34);
    border-radius: 50%;

    @include respond-to('desktop') {
      width: rem-calc(45);
      height: rem-calc(45);
    }
    @include respond-to('mobile') {
      display: block;
      margin: 0 auto;
    }
  }
  .quick-stats {
    width: 33.3333%;
    padding: rem-calc(0 5);
    float: left;
    box-sizing: border-box;
    text-align: center;
    max-width: rem-calc(175);

    @include respond-to("desktop") {
      padding: rem-calc(0 15);
      max-width: 100%;
    }

    &-wrapper {
      display: flex;
      justify-content: left;

      @media (max-width: 369px) {
        margin-bottom: rem-calc(-75);
      }

      @media (min-width: 370px) and (max-width: 409px) {
        margin-bottom: rem-calc(-45);
      }

      @media (min-width: 410px) and (max-width: 459px) {
        margin-bottom: rem-calc(-25);
      }

      @include respond-to("desktop") {
        padding: rem-calc(0 5);
      }
    }

    h3 {
      display: inline-block;
      font-family: $barlow;
      font-size: rem-calc(14);
      text-transform: none;
      color: $darker-gray-2;

      @include respond-to("desktop") {
        font-size: rem-calc(20);
        margin-left: rem-calc(6);
        line-height: rem-calc(45);
        margin-bottom: rem-calc(15);
      }

      @include respond-to("mobile") {
        line-height: 100%;
        margin-top: rem-calc(1);
        margin-bottom: rem-calc(5);
        display: block;
      }
    }
    .header {
      vertical-align:  middle;

      @include respond-to("desktop") {
        text-align: left;
      }
    }
    .infographics {
      background: $darker-gray-2-5;
      border-radius: rem-calc(10);
      padding: rem-calc(6.7 10 20);
      min-width: rem-calc(130);

      @media (max-width: 369px) {
        transform: scale(0.7);
        transform-origin: top left;
      }

      @media (min-width: 370px) and (max-width: 409px) {
        transform: scale(0.8);
        transform-origin: top left;
      }

      @media (min-width: 410px) and (max-width: 450px) {
        transform: scale(0.9);
        transform-origin: top left;
      }

      @include respond-to(desktop) {
        display: flex;
        justify-content: space-evenly;
        align-items: baseline;
      }

      .infographic:not(:first-child) {
        margin-top: rem-calc(10);
      }

      .infographic {
        /deep/ .infographic-background .add-color {
          fill: $soft-rose;
          color: $soft-rose;

          svg {
            fill: $soft-rose;
          }
        }
      }
    }
  }

  .impression-tracker {
    width: rem-calc(1);
    height: rem-calc(1);
  }
</style>



// WEBPACK FOOTER //
// components/tech-city/news-view/QuickStat.vue